/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */

import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { InventoryCountBase } from 'shared/dbo/InventoryCount';

export interface InventoryCountIndexedDb {
	id: string;
	endTime?: number;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isInventoryCountIndexedDb = (obj: unknown): obj is InventoryCountIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (hasPropOfType<{ endTime: unknown }>(obj, 'endTime') && !(typeof obj.endTime === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: InventoryCountBase): InventoryCountIndexedDb => ({
	id: obj.id.toString(),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	endTime: obj.endTime == null ? undefined : obj.endTime.epochMilliseconds,
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: InventoryCountIndexedDb): InventoryCountBase => ({
	id: UUID.fromString(obj.id),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	endTime: obj.endTime == null ? undefined : Temporal.Instant.fromEpochMilliseconds(obj.endTime),
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdInventoryCount: LocalDatabaseTableDefinition<InventoryCountBase, InventoryCountIndexedDb> = {
	tableName: 'inventoryCounts',
	indexColumns: [],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
